export default __webpack_public_path__ + "16d63582b67cd2adfe8dd92bd0baf1e5.png";